module.exports = __webpack_public_path__ + "static/img-step-1@3x-5d6db7ecfb2e3784a473c4fabf73af25.png";